import React, { useEffect, useState, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { collection, query, where, onSnapshot } from "firebase/firestore";
import { db } from "../../firebase/firebase";

import "./Sidebar.css";

export default function Sidebar() {
  const location = useLocation();
  const navigate = useNavigate();

  const [pendentes, setPendentes] = useState(0);
  const [isOpen, setIsOpen] = useState(false);
  const [activeSectionId, setActiveSectionId] = useState("dashboard");

  // SVG — seta igual ao Ideris
  const ArrowIcon = (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="#d94880"
      strokeWidth="2.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M9 18l6-6-6-6" />
    </svg>
  );

  // 🔥 Contador de pendentes
  useEffect(() => {
    const q = query(
      collection(db, "verificacoes"),
      where("status", "==", "pending")
    );

    const unsub = onSnapshot(q, (snap) => {
      setPendentes(snap.size);
    });

    return () => unsub();
  }, []);

  // Estrutura do menu
  const MENU = useMemo(
    () => [
      {
        id: "dashboard",
        label: "Dashboard",
        icon: "fas fa-chart-line",
        route: "/dashboard",
        submenus: [],
      },
      {
        id: "usuarios",
        label: "Usuários",
        icon: "fas fa-users",
        submenus: [
          {
            id: "usuarios_lista",
            label: "Lista Básica",
            icon: "fas fa-users",
            route: "/usuarios",
          },
          {
            id: "usuarios_gerenciar",
            label: "Gerenciar Usuários",
            icon: "fas fa-user-gear",
            route: "/usuarios-gerenciar",
          },
        ],
      },
      {
        id: "verificacoes",
        label: "Verificações",
        icon: "fas fa-shield-heart",
        submenus: [
          {
            id: "ver_geral",
            label: "Visão Geral",
            icon: "fas fa-eye",
            route: "/verificacoes",
          },
          {
            id: "ver_pendentes",
            label: "Pendentes",
            icon: "fas fa-hourglass-half",
            route: "/verificacoes/pendentes",
            badge: pendentes,
          },
          {
            id: "ver_aprovadas",
            label: "Aprovadas",
            icon: "fas fa-badge-check",
            route: "/verificacoes/aprovadas",
          },
          {
            id: "ver_rejeitadas",
            label: "Rejeitadas",
            icon: "fas fa-times-circle",
            route: "/verificacoes/rejeitadas",
          },
        ],
      },
      {
        id: "operadores",
        label: "Operadores",
        icon: "fas fa-headset",
        submenus: [
          {
            id: "oper_atendentes",
            label: "Atendentes",
            icon: "fas fa-headset",
            route: "/operadores",
          },
          {
            id: "oper_criar",
            label: "Criar Atendente",
            icon: "fas fa-user-plus",
            route: "/operadores/novo",
          },
        ],
      },
      {
        id: "ia",
        label: "Relacionamentos & IA",
        icon: "fas fa-robot",
        submenus: [
          {
            id: "ia_matchs",
            label: "Matchs",
            icon: "fas fa-heart",
            route: "/matchs",
          },
          {
            id: "ia_ia",
            label: "IA do Amor",
            icon: "fas fa-robot",
            route: "/ia",
          },
          {
            id: "ia_dashboard",
            label: "Dashboard IA",
            icon: "fas fa-desktop",
            route: "/ia-dashboard",
          },
        ],
      },
      {
        id: "conteudos",
        label: "Conteúdos",
        icon: "fas fa-book-open",
        submenus: [
          // ✅ NOVO: Horóscopo Semanal (alimenta o app)
          {
            id: "cont_horoscopo_semanal",
            label: "Horóscopo Semanal (App)",
            icon: "fas fa-sun",
            route: "/horoscopo-semanal",
          },

          // ✅ NOVO: Leads do Mapa Astral (rascunhos / checkout iniciado)
          {
            id: "cont_astro_map_leads",
            label: "Mapa Astral (Leads)",
            icon: "fas fa-star",
            route: "/astro-map-leads",
          },

          // ✅ NOVO: Ebooks (alimenta o app)
          {
            id: "cont_ebooks",
            label: "Ebooks (App)",
            icon: "fas fa-book",
            route: "/ebooks",
          },

          // (Se quiser manter uma tela antiga /horoscopo no futuro, pode duplicar aqui)
          // { id: "cont_horoscopo", label: "Horóscopo (antigo)", icon: "fas fa-sun", route: "/horoscopo" },

          {
            id: "cont_numerologia",
            label: "Numerologia",
            icon: "fas fa-calculator",
            route: "/numerologia",
          },
          {
            id: "cont_produtos",
            label: "Produtos de Beleza",
            icon: "fas fa-wand-magic-sparkles",
            route: "/produtos-beleza",
          },
        ],
      },
      {
        id: "planos",
        label: "Planos",
        icon: "fas fa-crown",
        submenus: [
          {
            id: "planos_geral",
            label: "Planos",
            icon: "fas fa-crown",
            route: "/planos",
          },
          {
            id: "planos_usuario",
            label: "Plano do Usuário",
            icon: "fas fa-user-shield",
            route: "/usuario-plano",
          },
          {
            id: "planos_chaves",
            label: "Chaves de Ativação",
            icon: "fas fa-key",
            route: "/chaves",
          },

          // ✅ NOVO: Assinaturas (Kiwify MVP)
          {
            id: "planos_assinaturas",
            label: "Assinaturas",
            icon: "fas fa-receipt",
            route: "/assinaturas",
          },
        ],
      },
      {
        id: "atualizacoes",
        label: "Atualizações",
        icon: "fas fa-bullhorn",
        submenus: [
          {
            id: "up_feed",
            label: "Feed de Updates",
            icon: "fas fa-bullhorn",
            route: "/updates-feed",
          },
          {
            id: "up_historico",
            label: "Histórico de Updates",
            icon: "fas fa-clock-rotate-left",
            route: "/historico-updates",
          },
          {
            id: "up_notificar",
            label: "Enviar Notificação",
            icon: "fas fa-bell",
            route: "/enviar-notificacao",
          },
          {
            id: "up_hist_notif",
            label: "Histórico Notificações",
            icon: "fas fa-envelope-open-text",
            route: "/historico-notificacoes",
          },
        ],
      },
    ],
    [pendentes]
  );

  // Define seção ativa
  useEffect(() => {
    const currentPath = location.pathname;

    let foundSection = "dashboard";

    MENU.forEach((section) => {
      if (section.route === currentPath) foundSection = section.id;
      section.submenus?.forEach((sub) => {
        if (sub.route === currentPath) foundSection = section.id;
      });
    });

    setActiveSectionId(foundSection);
  }, [location.pathname, MENU]);

  // Eventos vindos do Topbar
  useEffect(() => {
    const handleToggle = () => setIsOpen((prev) => !prev);
    const handleClose = () => setIsOpen(false);

    window.addEventListener("toggleMainMenu", handleToggle);
    window.addEventListener("closeMainMenu", handleClose);

    return () => {
      window.removeEventListener("toggleMainMenu", handleToggle);
      window.removeEventListener("closeMainMenu", handleClose);
    };
  }, []);

  const handleNavigate = (path) => {
    navigate(path);
    window.dispatchEvent(new Event("closeMainMenu"));
  };

  const activeSection = MENU.find((s) => s.id === activeSectionId);
  const hasSubmenus = activeSection && activeSection.submenus?.length > 0;

  if (!isOpen) return null;

  return (
    <>
      {/* Backdrop */}
      <div className="mega-menu-backdrop" onClick={() => setIsOpen(false)} />

      <div className="mega-menu-wrapper">
        <div className="mega-menu-panel">
          <div className="mega-menu-inner">
            {/* COLUNA ESQUERDA */}
            <div className="mega-menu-left">
              {/* 🔥 HEADER VAZIO IGUAL AO IDERIS */}
              <div className="mega-menu-left-header"></div>

              {MENU.map((section) => {
                const isActive = section.id === activeSectionId;
                const isDashboard = section.id === "dashboard";

                return (
                  <button
                    key={section.id}
                    type="button"
                    className={`mega-menu-main-item ${isActive ? "active" : ""}`}
                    onMouseEnter={() => setActiveSectionId(section.id)}
                    onClick={() =>
                      isDashboard
                        ? handleNavigate(section.route)
                        : setActiveSectionId(section.id)
                    }
                  >
                    <div className="mega-menu-main-left">
                      <i className={section.icon} />
                      <span>{section.label}</span>
                    </div>

                    {/* SETA SVG */}
                    {!isDashboard && (
                      <span className="arrow-svg">{ArrowIcon}</span>
                    )}
                  </button>
                );
              })}
            </div>

            {/* COLUNA DIREITA */}
            <div className="mega-menu-right">
              {hasSubmenus ? (
                <>
                  <h4 className="mega-menu-right-title">{activeSection.label}</h4>

                  <div className="mega-menu-submenu-list">
                    {activeSection.submenus.map((sub) => (
                      <button
                        key={sub.id}
                        type="button"
                        className="mega-menu-sub-item"
                        onClick={() => handleNavigate(sub.route)}
                      >
                        <div className="mega-menu-sub-left">
                          <i className={sub.icon} />
                          <span>{sub.label}</span>
                        </div>

                        {sub.badge > 0 && (
                          <span className="badge-pendentes">{sub.badge}</span>
                        )}
                      </button>
                    ))}
                  </div>
                </>
              ) : (
                <div className="mega-menu-empty">
                  <h4>Dashboard</h4>
                  <p>Acesse a visão geral do painel administrativo do One Love.</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
 